import _ from 'lodash';

import { SITE_NAME } from 'constants/general';

const TITLE_PLACEHOLDER = '%s';
const ROOT_TITLE_TEMPLATE = `${SITE_NAME} - ${TITLE_PLACEHOLDER}`;

class DocumentTitleRegistry {
  #entries = [];

  claimEntry = entryId => {
    if (this.#entries.some(entry => entry.entryId === entryId)) {
      return;
    }

    this.#entries.push({ entryId });
  };

  setEntry = (entryId, { title, defaultTitle, titleTemplate, prefix }) => {
    this.#entries = this.#entries.map(entry =>
      entry.entryId === entryId ? { entryId, title, defaultTitle, titleTemplate, prefix } : entry,
    );

    this.#apply();
  };

  removeEntry = entryId => {
    this.#entries = this.#entries.filter(entry => entry.entryId !== entryId);

    this.#apply();
  };

  #resolveInnermost = key =>
    this.#entries.reduce(
      (innermost, entry) => (_.isNil(entry[key]) ? innermost : entry[key]),
      null,
    );

  #resolveBaseTitle = () => {
    const title = this.#resolveInnermost('title');
    const titleTemplate = this.#resolveInnermost('titleTemplate') ?? ROOT_TITLE_TEMPLATE;
    const defaultTitle = this.#resolveInnermost('defaultTitle') ?? SITE_NAME;

    return _.isEmpty(title)
      ? defaultTitle
      : titleTemplate.replaceAll(TITLE_PLACEHOLDER, () => title);
  };

  #apply = () => {
    if (typeof document === 'undefined') {
      return;
    }

    document.title = `${this.#resolveInnermost('prefix') ?? ''}${this.#resolveBaseTitle()}`;
  };
}

export default new DocumentTitleRegistry();
